import h from 'hyperscript';
import { generateIcon as icon } from 'components/_particles/icon/icon';
import { t } from '../../../javascripts/utils/withTranslation';

/**
* To really sort the table we use jquery tablesorter embedded on each site
* see bottom of src/templates/layouts/_main.pug
*/
export default class SortableTable {
  constructor($table) {
    this.$table = $table;
    this.$sortToggleButtons = $table.querySelectorAll('.table__head-cell--sortable');

    this.init();
  }

  /**
   * Add sort item to sortable columns
   */
  init = () => {
    this.$sortToggleButtons.forEach(($sortToggle) => {
      const $toggleButton = h(
        'button.table__sort',
        {
          type: 'button',
          attrs: {
            'aria-label': t('Tabelle sortieren'),
          },
        },
        icon({
          icon: 'arrow-down',
          viewBox: '0 0 200 200',
          className: 'table__sort-icon',
        }),
      );

      $sortToggle.appendChild($toggleButton);
    });
  }
}

// Init SortableTable
document.querySelectorAll('.table--sortable').forEach($tableSortable => new SortableTable($tableSortable));
